export enum ItemSize {
  LARGE = 'large',
  MEDIUM = 'medium',
  SMALL = 'small',
}
